export const digEcoSysYouTubeUrl = 'https://www.youtube.com/embed/RXuLyOOcmaY';
